// extracted by mini-css-extract-plugin
module.exports = {"cont-tab":"BizTabs_cont-tab__3LM5j","btn-tab":"BizTabs_btn-tab__HKbLN","bar":"BizTabs_bar__18ZDc"};